// extracted by mini-css-extract-plugin
export default {"sidebar":"BurgerMenu_sidebar__rRyb5","container":"BurgerMenu_container__Fr+p2","bg":"BurgerMenu_bg__d-t+J"};